<template>
    <v-data-table
            style="width: 100%;"
            :items="pendingItems"
            hide-default-footer
            hide-default-header
            disable-pagination>
        <template v-slot:item="{ item }">
            <v-card outlined color="darken-1" elevation="0" class="mb-2">
                <v-card-actions class="ma-0 pa-0">
                    <v-card-text class="blue--text ma-0 pa-0 ml-2 mt-0">{{item}}</v-card-text>
                    <v-spacer></v-spacer>
                    <v-btn class="mt-0 mr-1" icon color="red" @click="onPressDelete(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-card-actions class="ma-0 pa-0">
                    <v-autocomplete style="margin-bottom: -20px; margin-left: 8px; margin-right: 8px"
                                    label="Aud"
                                    v-model="aud[item]"
                                    dense
                                    :items="audiences"
                                    outlined
                                    item-text="name"
                                    item-value="name"
                                    return-object
                                    small-chips
                                    deletable-chips
                                    :multiple="true"
                    ></v-autocomplete>
                </v-card-actions>
            </v-card>
        </template>
    </v-data-table>
</template>
<script>


import {DeployStoreUtils} from "@/modules/mdeploy/database/DeployStoreUtils";
import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";

export default {
    name: "d-list-table",
    data: () => ({
        aud: {},
    }),
    methods:{
        onPressDelete(item){
            this.$confirm("Are you sure?")
            .then(() => {
                this.$store.commit("deploy-store/removePendingForDeploy", item);
            }).catch(() => {})
        },
    },
    computed:{
        audiences() {
            return AudienceTestStoreUtils.getAudiences()
        },
        pendingItems(){
            return DeployStoreUtils.getPendingForDeploy()
        }
    }
}
</script>

<style scoped>
</style>